import Pricing from "./pricing/index.jsx";
import Faq from "./faq/index.jsx";
import Legacy from "./legacy/index.jsx";
import UserAgreement from "./userAgreement/index.jsx";
import UserAgreementCommercial from "./userAgreementCommercial/index.jsx";
import Contact from "./contact/index.jsx";
import ContactCryptoPayment from "./contactCryptoPayment/index.jsx";
import Footer from "./footer.jsx";
import Home from "./home/index.jsx";
import Login from "./login/home/index.jsx";
import LoginForgot from "./login/forgot/index.jsx";
import LoginLogout from "./login/logout/index.jsx";
import LoginReset from "./login/reset/index.jsx";
import LoginConfirm from "./login/confirm/index.jsx";
import Navbar from "./navbar.jsx";
import NotFound from "./not-found.jsx";
import React from "react";
import { Route, Switch ,Redirect } from "react-router-dom";
import RouteRedirect from "../../components/route-redirect.jsx";
import SignupAccountAPI from "./signupAccountAPI/index.jsx";
import SignupAccountAPIConfirm from "./signupAccountAPI/confirm/index.jsx";

import { Helmet } from "react-helmet";

const AppUniversal = function () {
  return (
    <div>
      {process.env.CMC_PORTAL_ENV !== "production" && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      <Route component={Navbar} />
      <Switch>
        <Route path="(/|/api)" exact component={Home} />
        <Route path="/(api/pricing|pricing)" exact component={Pricing} />
        <Redirect from="/(api/features|features)" to='/api/pricing'/>
        <Route path="/(api/faq|faq)" component={Faq} />
        <Route path="/(api/migrate|migrate)" exact component={Legacy} />
        <Route
          path="/(api/user-agreement-personal|user-agreement|user-agreement-personal)"
          exact
          component={UserAgreement}
        />
        <Route
          path="/(v1/user-agreement-commercial|user-agreement-commercial)"
          exact
          component={UserAgreementCommercial}
        />
        <Route path="/(v1/contact|contact)" exact component={Contact} />
        <Route
          path="/contact-crypto-payment"
          exact
          component={ContactCryptoPayment}
        />

        <Route path="/login" exact component={Login} />
        <Route path="/login/forgot" exact component={LoginForgot} />
        <Route path="/login/logout" exact component={LoginLogout} />
        <Route path="/login/reset/:email/:key" component={LoginReset} />
        <Route path="/login/reset" component={LoginReset} />
        <Route path="/login/confirm/:email/:key" component={LoginConfirm} />
        <Route path="/login/confirm" component={LoginConfirm} />

        <Route path="/signup" exact component={SignupAccountAPI} />
        <Route
          path="/signup/success/:email"
          exact
          component={SignupAccountAPIConfirm}
        />
        <Route
          path="/signup/confirm/:email"
          exact
          component={SignupAccountAPIConfirm}
        />
        <Route
          path="/signup/confirm/:email/:key"
          exact
          component={SignupAccountAPIConfirm}
        />
        <Route
          path="/signup/confirm"
          exact
          component={SignupAccountAPIConfirm}
        />
        <Route
          path="/signup/success"
          exact
          component={SignupAccountAPIConfirm}
        />

        <RouteRedirect from="/moved" to="/" code={301} />

        <Route component={NotFound} />
      </Switch>
      <Footer />
    </div>
  );
};

export default AppUniversal;



// WEBPACK FOOTER //
// ./client/pages/main/app-universal.jsx